import { EnvironmentProviders, inject, provideAppInitializer, Provider } from '@angular/core';

import {
    ActualAppVersionClient,
    AppActualVersionEnforcer,
    BackendActualAppVersionClient,
    BackendMobileAppActualVersionEnforcer
} from '@guardfinder/shared';

import { firstValueFrom } from 'rxjs';

import { GuardActualAppVersionEnforcer } from '../infrastructure/guard-actual-app-version-enforcer.service';

export function provideAppLoadProVersionCheck(): Provider | EnvironmentProviders[] {
    return [
        { provide: AppActualVersionEnforcer, useExisting: BackendMobileAppActualVersionEnforcer },
        { provide: ActualAppVersionClient, useExisting: BackendActualAppVersionClient },
        provideAppInitializer(() => {
            const env = import.meta.env['NG_APP_ENV'];
            if (env !== 'production') {
                return;
            }
            const versionEnforcer = inject(GuardActualAppVersionEnforcer);
            return firstValueFrom(versionEnforcer.execute());
        })
    ];
}
